import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, Text, useColorMode } from '@abb/uikit';
import { mode } from '@abb/uikit';
import { useCheckFatca } from 'hooks';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import InfoIcon from 'shared-components/icons/InfoIcon';
export function FatcaAlert() {
    const { colorMode } = useColorMode();
    const { t } = useTranslation();
    const cancelRef = useRef();
    const navigate = useNavigate();
    const { data } = useCheckFatca();
    const [isPromoClosed, setIsPromoClosed] = useState(false);
    useEffect(()=>{
        if (localStorage.getItem('isModalShowed') !== 'yes') {
            setTimeout(()=>{
                setIsPromoClosed(true);
            }, 3000);
        }
        localStorage.setItem('isModalShowed', 'yes');
    }, []);
    if (!data || data && data.fatcaStatus !== 'OLD') {
        return null;
    }
    return /*#__PURE__*/ _jsxs(AlertDialog, {
        motionPreset: "slideInBottom",
        leastDestructiveRef: cancelRef,
        onClose: ()=>setIsPromoClosed(false),
        isOpen: isPromoClosed,
        isCentered: true,
        children: [
            /*#__PURE__*/ _jsx(AlertDialogOverlay, {}),
            /*#__PURE__*/ _jsxs(AlertDialogContent, {
                color: mode('gray.700', 'white')({
                    colorMode
                }),
                bg: mode('#FFFFFF', '#232324')({
                    colorMode
                }),
                width: "408px",
                children: [
                    /*#__PURE__*/ _jsxs(AlertDialogHeader, {
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ _jsx(InfoIcon, {
                                width: '40px',
                                height: '40px',
                                color: "#2058BB",
                                mb: "10px",
                                transform: "rotate(180deg)"
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                color: mode('#0D0D19', '#FFFFFF')({
                                    colorMode
                                }),
                                children: t('common:fatca_crs.alert')
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(AlertDialogBody, {
                        textAlign: "center",
                        color: mode('#000000A3', '#FFFFFF7A')({
                            colorMode
                        }),
                        px: "40px",
                        children: t('common:fatca_crs.alert_text')
                    }),
                    /*#__PURE__*/ _jsxs(AlertDialogFooter, {
                        boxShadow: "none",
                        display: "flex",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "ghost",
                                backgroundColor: mode('#EBEBF2', '#282829')({
                                    colorMode
                                }),
                                ref: cancelRef,
                                onClick: ()=>setIsPromoClosed(false),
                                children: t('common:actions.later')
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                colorScheme: "brand",
                                ml: 3,
                                onClick: ()=>{
                                    navigate('/fatca-crs');
                                    setIsPromoClosed(false);
                                },
                                children: t('common:actions.refresh')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
